import { request } from 'services/http/dashboard-ui/instance'

export const getRelationships = (userName: string) =>
  request<any>({
    method: 'get',
    url: 'account/relationships',
    params: { userName },
  })
